import React, { useEffect, useRef, useState, useCallback } from 'react';
import optionMenu from '../../../images/icons/three-dots-vertical.png';
import urgentIcon from '../../../images/icons/urgent.svg';
import mergeIcon from '../../../images/icons/merge.svg';
import { ReactComponent as DeletIcon } from '../../../images/icons/delete.svg';
import "./index.css";
import { useOutsideClickHandler } from '../../../hooks';

const ThreeDotsMenu = ({ cardId, orderGuid, isUrgent, openMenuId, setOpenMenuId, openDeleteModal, onUpdateOrder }) => { 
  const [isOpen,setIsOpen]=useState()
  const [loading, setLoading] = useState(false);
  // const isOpen = openMenuId === cardId;
  const menuRef = useRef(null);
useEffect(()=>{
if(openMenuId === cardId){
  setIsOpen(true)
}else{
  setIsOpen(false)
}
},[openMenuId,cardId])
  const toggleMenu = (e) => {
    e.stopPropagation();
    if (isOpen) {
      setOpenMenuId(null);
    } else {
      setOpenMenuId(cardId);
    }
  };

  useOutsideClickHandler(menuRef, () => setOpenMenuId(null))

  const handleToggleUrgent = useCallback(async (e) => {
    e.stopPropagation();
    if (onUpdateOrder && orderGuid) {
      setLoading(true);
      try {
        const newUrgentValue = !isUrgent;
        await onUpdateOrder(orderGuid, 'urgent', newUrgentValue);
        setOpenMenuId(null);
      } catch (error) {
        console.error("Error updating urgent status:", error);
      } finally {
        setLoading(false);
      }
    }
  }, [onUpdateOrder, orderGuid, isUrgent, setOpenMenuId]);

 

  return (
    <div className="menu-container" style={{ position: 'relative', display: 'inline-block' }}  >
      <button 
        onClick={toggleMenu}
        className={`threedot-menu-btn ${isOpen ? 'menu-open' : ''}`}
        aria-label="More options"
      
      >
        <img src={optionMenu} alt="Options" />
      </button>
      
      {isOpen && (
        <div className='menuList-wrapper' onClick={(e) => e.stopPropagation()}   ref={menuRef} >
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li 
              className='menuList-item' 
              onClick={handleToggleUrgent}
              style={{ 
                opacity: loading ? 0.6 : 1,
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              <img src={urgentIcon} height={17} width={17} alt={isUrgent ? "Non-urgent" : "Urgent"} />
              {isUrgent ? 'Non-urgent' : 'Urgent'}
              {loading && (
                <div
                  style={{
                    width: '14px',
                    height: '14px',
                    border: '2px solid #ccc',
                    borderTop: '2px solid #000',
                    borderRadius: '50%',
                    animation: 'spin 0.6s linear infinite',
                    marginLeft: 'auto'
                  }}
                ></div>
              )}
            </li>
            {/* <li className='menuList-item' style={{ borderBottom: '1px solid #eee' }} onClick={(e) => e.stopPropagation()}>
              <img src={mergeIcon} height={17} width={17} alt="Merge" />Merge
            </li> */}
            <li className='menuList-item menuList-item-delete' onClick={(e)=>{
    openDeleteModal(e);e.stopPropagation()}}>
              <div style={{height:17,width:17}}><DeletIcon/></div>Delete Order
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default ThreeDotsMenu;